import { render } from "./LandingPage.vue?vue&type=template&id=24c11ef8&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=24c11ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c11ef8"]])

export default __exports__